module.exports = __webpack_public_path__ + "static/media/676dde03488437c2c6a18ecb92291e58.e9080402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/676dde03488437c2c6a18ecb92291e58.jpg
// module id = 289
// module chunks = 0